export enum OrderObjectTestIds {
  GENERAL_DATA_ERROR_ICON = 'order-object-general-data-error-icon',
  DETAILS_TOGGLE_ERROR_ICON = 'order-object-details-toggle-error-icon',
  GENERAL_DATA_CUSTOMER = 'order-general-data-customer',
  GENERAL_DATA_SELLER = 'order-general-data-seller',
  GENERAL_DATA_SALES_REPRESENTATIVE = 'order-general-data-sales-representative',
  GENERAL_DATA_PRICE_TABLE = 'order-general-data-price-table',
  GENERAL_DATA_CONSULTANT = 'order-general-data-consultant',
  TAB_OVERVIEW = 'order-object-tab-overview',
  TAB_ACTIVITIES = 'order-object-tab-activities',
  TAB_TARGETS = 'order-object-tab-targets',
  TAB_PRODUCTS = 'order-object-tab-products',
  TAB_CONDITIONS = 'order-object-tab-conditions',
}

export enum OrderObjectTargetsTestIds {
  EMPTY_STATE = 'order-object-targets-empty',
  TOGGLE_BUTTON = 'order-object-targets-toggle',
  VIEW_BUTTON = 'order-object-targets-view-button',
  COLLAPSE_ALL_BUTTON = 'order-object-targets-collapse-all-button',
  EXPAND_ALL_BUTTON = 'order-object-targets-expand-all-button',
  SUMMARY_CARD = 'order-object-targets-summary-card',
  SUMMARY_LINK = 'order-object-targets-summary-link',
}

export enum OrderObjectActivitiesTestIds {
  LIST_CONTAINER = 'order-object-activities-list',
  LIST_ITEM = 'order-object-activities-list-item',
  EMPTY_STATE = 'order-object-activities-empty',
  DOWNLOAD_SNAPSHOT_BUTTON = 'order-object-activities-download-snapshot',
}
